<div class="file-entry">
  <div class="file-entry-content" [nbSpinner]="true" nbSpinnerStatus="primary">
    <nb-icon pack="eva" class="file-icon" [icon]="getIcon()"></nb-icon>
    <b>{{getFilename()}}</b>
  </div>
  <button nbButton (click)="deleteFile()">
    <nb-icon pack="eva" icon="close-outline"></nb-icon>
  </button>
</div>
